import { s as script } from './Input-cb6c4f29.js';
export { s as BInput } from './Input-cb6c4f29.js';
import { u as use, a as registerComponent } from './plugins-9a909142.js';
import './Icon-52393747.js';
import './config-86592f14.js';
import './helpers-8130329a.js';
import './typeof-92b42de1.js';
import 'vue';
import './FormElementMixin-6da0c31e.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};
use(Plugin);

export { Plugin as default };
